import { tw } from "@careinfo/tailwind";
import React from "react";
import Button from "../Reusable/Button";

const CargoBranchInvoicePopup = (props: any) => {
  const {
    handleCreate,
    isLoading,
    user,
    setError,
    getValues,
    invoiceReport,
    setOrderData,
  } = props;
  return (
    <>
      <>
        <div className="flex justify-between mt-8">
          <div>Total Number of order:</div>
          <div>{invoiceReport?.totalOrder}</div>
        </div>
        <div className="flex justify-between mt-2">
          <div> Branch Rate:</div>
          <div>{invoiceReport?.totalBranchCharge}</div>
        </div>
        <div className="flex justify-between mt-2 font-bold">
          <div>Net Payable</div>
          <div>{Number(invoiceReport?.totalAmount)}</div>
        </div>
        <div className={tw`mx-auto w-full flex justify-end`}>
          <div className={tw`w-40`}>
            <Button
              label={"Generate Statement"}
              isLoading={isLoading}
              onClick={() => {
                handleCreate(getValues(), setError);
                setOrderData([]);
              }}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default CargoBranchInvoicePopup;
